// docs: https://github.com/altostra/type-validations#readme
import { objectOf, arrayOf } from "@altostra/type-validations";
import { string, number } from "@altostra/type-validations/lib/primitives";

export const isCompaniesCompanyIdDevelopersPermissionStructuresResult = objectOf({
  permission_sets: arrayOf(
    objectOf({
      id: string,
      permissions: arrayOf(number),
      name: string,
      number_of_assignee_developers: number,
      number_of_app_groups: number,
      number_of_territories: number,
      last_updated_at: string,
    })
  ),
});
